document.addEventListener('DOMContentLoaded', function() {
    const heroVideos = document.querySelectorAll('.hero-video');
  
    heroVideos.forEach(heroVideo => {
      const video = heroVideo.querySelector('video');
      if (video) {
        video.addEventListener('canplay', () => {
          video.play();
        });
      }
    });
  });